/* eslint-disable no-underscore-dangle */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var snakeToCamel = function (str) {
    return str
        .toLowerCase()
        .replace(/([-_][a-z])/g, function (group) {
        return group.toUpperCase().replace('-', '').replace('_', '');
    });
};
var parseProps = function (obj) {
    var camelCased = {};
    Object.entries(obj).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        camelCased[snakeToCamel(key)] = value;
    });
    return camelCased;
};
export var defineElement = function (_a) {
    var name = _a.name, initialProps = _a.initialProps, _b = _a.shadowDom, shadowDom = _b === void 0 ? true : _b, renderFn = _a.renderFn;
    return function (env, css, externalCss) {
        customElements.define(name, /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super.call(this) || this;
                _this.initialRender = true;
                _this.receiveRoutingEvent = null;
                _this.props = __assign(__assign({}, initialProps), { env: env });
                _this.placeholder = document.createElement('div');
                if (shadowDom) {
                    _this.attachShadow({ mode: 'open' });
                }
                return _this;
            }
            Object.defineProperty(class_1, "observedAttributes", {
                get: function () {
                    if (!initialProps) {
                        return [];
                    }
                    return Object.keys(initialProps);
                },
                enumerable: false,
                configurable: true
            });
            class_1.prototype.connectedCallback = function () {
                var _this = this;
                var target = shadowDom ? this.shadowRoot : this;
                this.getAttributeNames().forEach(function (attributeName) {
                    _this.props[attributeName] = _this.getAttribute(attributeName);
                });
                this.initialRender = false;
                var head = document.createElement('head');
                target === null || target === void 0 ? void 0 : target.appendChild(head);
                target === null || target === void 0 ? void 0 : target.appendChild(this.placeholder);
                if (css) {
                    var link = document.createElement('style');
                    link.innerHTML = "@import \"".concat(css, "\"");
                    target === null || target === void 0 ? void 0 : target.appendChild(link);
                    link.onload = function () {
                        renderFn(_this.placeholder, parseProps(_this.props));
                    };
                }
                else {
                    renderFn(this.placeholder, parseProps(this.props));
                }
                if (externalCss) {
                    var link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = externalCss;
                    document.head.appendChild(link);
                }
            };
            class_1.prototype.attributeChangedCallback = function (attrName, _, newVal) {
                this.props[attrName] = newVal;
                if (!this.initialRender) {
                    renderFn(this.placeholder, parseProps(this.props));
                }
            };
            class_1.prototype.disconnectedCallback = function () {
                var _a;
                (_a = this.receiveRoutingEvent) === null || _a === void 0 ? void 0 : _a.removeListener();
            };
            return class_1;
        }(HTMLElement)));
        return name;
    };
};
export { default as useConfig } from './utils/use-config';
export * from '../../shared/src/index';
export default defineElement;
